// src/store/billerRegions/billerRegions.slice.ts
import { createSlice } from "@reduxjs/toolkit";
import type { BillerRegion } from "services/api.services/biller/billerRegionsService";
import {
  fetchBillerRegionsRequested,
  fetchBillerRegionsSucceeded,
  fetchBillerRegionsFailed,
  resetBillerRegions,
} from "./billerRegionsActions";

export interface BillerRegionsState {
  items: BillerRegion[];
  loading: boolean;
  error: string | null;
  search: string;
  returnItems: number;
}

const initialState: BillerRegionsState = {
  items: [],
  loading: false,
  error: null,
  search: "",
  returnItems: 0,
};

const billerRegionsSlice = createSlice({
  name: "billerRegions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBillerRegionsRequested, (state, action) => {
        state.loading = true;
        state.error = null;
        state.search = action.payload.search;
      })
      .addCase(fetchBillerRegionsSucceeded, (state, action) => {
        state.loading = false;
        state.error = null;
        state.items = action.payload.items;
        state.returnItems = action.payload.returnItems;
      })
      .addCase(fetchBillerRegionsFailed, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load regions.";
        state.items = [];
        state.returnItems = 0;
      })
      .addCase(resetBillerRegions, () => initialState);
  },
});

export default billerRegionsSlice.reducer;
